import { render, staticRenderFns } from "./JoinUs.vue?vue&type=template&id=7c32ed58&scoped=true"
import script from "./JoinUs.vue?vue&type=script&lang=js"
export * from "./JoinUs.vue?vue&type=script&lang=js"
import style0 from "./JoinUs.vue?vue&type=style&index=0&id=7c32ed58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c32ed58",
  null
  
)

export default component.exports